var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaves(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 32,
    viewBox: "0 0 73 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0022c0",
    d: "M72.72 5.275c0 0-2.186 6.509-5.584 7.883-2.076 0.822-4.34 1.052-6.539 0.663 0 0 2.18-6.503 5.578-7.877 2.078-0.822 4.344-1.053 6.545-0.669z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0022c0",
    d: "M48.487 5.276c0 0-2.18 6.509-5.578 7.883-2.086 0.827-4.36 1.056-6.569 0.663 0 0 2.186-6.503 5.584-7.877 2.084-0.827 4.356-1.058 6.563-0.669z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00aa91",
    stroke: "#00aa91",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 9.0909,
    d: "M24.246 5.275c0 0-2.186 6.509-5.584 7.883-2.085 0.828-4.36 1.057-6.569 0.663 0 0 2.18-6.503 5.578-7.877 2.087-0.828 4.364-1.059 6.575-0.669z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0022c0",
    d: "M60.609 31.618c0 0-2.186-6.509-5.578-7.883-2.086-0.827-4.36-1.056-6.569-0.663 0 0 2.186 6.509 5.584 7.877 2.084 0.827 4.356 1.058 6.563 0.669z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0022c0",
    d: "M36.364 31.618c0 0-2.18-6.509-5.578-7.883-2.076-0.822-4.34-1.051-6.539-0.663 0 0 2.18 6.509 5.578 7.877 2.076 0.822 4.34 1.054 6.539 0.669z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0022c0",
    d: "M12.123 31.618c0 0-2.186-6.509-5.584-7.883-2.076-0.822-4.34-1.051-6.539-0.663 0 0 2.18 6.509 5.578 7.877 2.078 0.822 4.344 1.054 6.545 0.669z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaves);
export default __webpack_public_path__ + "static/media/leaves.508c3ad43b23ed414188fbe8a3f341ac.svg";
export { ForwardRef as ReactComponent };